import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import CouponModal from "./CouponModal";
import BillingService from "../../Billing/services/BillingService";
import CouponSnackbar from "./CouponSnackbar";
import Notification from "./Notification";
function CouponUI() {
    var location = useLocation();
    var _a = useState([]), coupons = _a[0], setCoupons = _a[1];
    var _b = useState(false), showModal = _b[0], setShowModal = _b[1];
    var _c = useState(false), showSnack = _c[0], setShowSnack = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var hasValidCoupon = function () { return coupons.length > 0; };
    var isInBillingPage = location.pathname.includes("/billing");
    var isInHomePage = location.pathname === "/";
    function isHomeModalDismissed() {
        return sessionStorage.getItem("home_modal_dismissed") === "true";
    }
    function markHomeModalDismissed() {
        sessionStorage.setItem("home_modal_dismissed", "true");
    }
    function markBillingSnackDismissed() {
        sessionStorage.setItem("billing_snack_dismissed", "true");
    }
    function dismissModal() {
        markHomeModalDismissed();
        setShowModal(false);
    }
    function closeSnackbar() {
        markBillingSnackDismissed();
        setShowSnack(false);
    }
    function reopenModal() {
        setShowSnack(false);
        setShowModal(true);
    }
    function redeemCoupon() {
        if (coupons.length === 0)
            return;
        var couponCode = coupons[0].name;
        if (!couponCode || couponCode.trim() === "") {
            Notification().Notify.failure("Cupom inválido");
            return;
        }
        var baseUrl = process.env.REACT_APP_CELETI_EXPRESS_URL;
        var discountUrl = "".concat(baseUrl, "/discount/").concat(encodeURIComponent(couponCode));
        window.open(discountUrl, "_blank", "noopener,noreferrer");
        setShowModal(false);
        setShowSnack(false);
    }
    useEffect(function () {
        BillingService.getDiscountCoupons()
            .then(function (res) {
            setCoupons(res.data.coupons);
            setLoading(false);
        })
            .catch(function (error) {
            Notification().Notify.failure("Erro ao carregar cupons", error);
            setLoading(false);
        });
    }, []);
    useEffect(function () {
        if (loading) {
            setShowModal(false);
            setShowSnack(false);
            return;
        }
        if (!isInHomePage && !isInBillingPage) {
            setShowModal(false);
            setShowSnack(false);
            return;
        }
        if (isInHomePage && hasValidCoupon()) {
            var shouldShowHomeModal = !isHomeModalDismissed();
            setShowModal(shouldShowHomeModal);
            setShowSnack(false);
            return;
        }
        if (isInBillingPage) {
            setShowModal(false);
            setShowSnack(true);
        }
    }, [loading, coupons, location.pathname]);
    if (loading)
        return null;
    var firstCoupon = coupons.length > 0 ? coupons[0] : null;
    var message = coupons.length === 0
        ? "Pague sua fatura e ganhe DESCONTO de até R$1.000"
        : "Você tem um CUPOM para resgatar!";
    return (_jsxs(_Fragment, { children: [hasValidCoupon() && (_jsx(CouponModal, { isOpen: showModal, couponName: (firstCoupon === null || firstCoupon === void 0 ? void 0 : firstCoupon.name) || "", onClose: dismissModal, onRedeem: redeemCoupon, validate: (firstCoupon === null || firstCoupon === void 0 ? void 0 : firstCoupon.validate) || "" })), _jsx(CouponSnackbar, { isOpen: showSnack, couponName: (firstCoupon === null || firstCoupon === void 0 ? void 0 : firstCoupon.name) || "", onReopen: reopenModal, onClose: closeSnackbar, message: message, isClickable: hasValidCoupon() })] }));
}
export default CouponUI;
